// frontend/src/api/endpoints/auth.ts

import { apiClient } from '@/api/client'
import type { LoginCredentials, RegisterData, AuthTokens, User } from '@/types'

export const authApi = {
  /**
   * Вход в систему
   */
  login: (data: LoginCredentials): Promise<{ access_token: string; refresh_token: string; user: User }> => {
    return apiClient.post('/v1/auth/login', data)
  },

  /**
   * Регистрация нового пользователя
   */
  register: (data: RegisterData): Promise<{ access_token: string; refresh_token: string; user: User }> => {
    return apiClient.post('/v1/auth/register', data)
  },

  /**
   * Обновление токена доступа
   */
  refreshToken: (refreshToken: string): Promise<AuthTokens> => {
    return apiClient.post('/v1/auth/refresh', { refresh_token: refreshToken })
  },

  /**
   * Выход из системы
   */
  logout: (): Promise<void> => {
    return apiClient.post('/v1/auth/logout')
  },

  /**
   * Получение текущего пользователя
   */
  getMe: (): Promise<User> => {
    return apiClient.get('/v1/auth/me')
  },

  /**
   * Запрос на сброс пароля
   */
  requestPasswordReset: (email: string): Promise<void> => {
    return apiClient.post('/v1/auth/request-password-reset', { email })
  },

  /**
   * Сброс пароля
   */
  resetPassword: (token: string, newPassword: string): Promise<void> => {
    return apiClient.post('/v1/auth/reset-password', { token, new_password: newPassword })
  },

  /**
   * Верификация email
   */
  verifyEmail: (userId: number, token: string): Promise<void> => {
    return apiClient.post('/v1/auth/verify-email', { user_id: userId, token })
  },

}
